import { jsx as l } from "@emotion/react/jsx-runtime";
import r from "prop-types";
import { BREAKPOINTS as m } from "../../constants.mjs";
import { GRID_GUTTER as e } from "./gridConstants.mjs";
import { css as o } from "@emotion/react";
import p from "./Col.mjs";
import f from "./Bleed.mjs";
const i = {
  grid: o`
        display: grid;
        grid-template-columns: [start] minmax(0, 1fr) [first-col-end middle last-col-start] minmax(0, 1fr) [end];
        grid-column-gap: ${e.SMALL};

        @media (min-width: ${m.MEDIUM}rem) {
            grid-template-columns:
                [start] minmax(0, 1fr) [first-col-end] repeat(2, minmax(0, 1fr)) [middle] repeat(
                    2,
                    minmax(0, 1fr)
                )
                [last-col-start] minmax(0, 1fr) [end];
            grid-column-gap: ${e.MEDIUM};
        }
        @media (min-width: ${m.LARGE}rem) {
            grid-template-columns:
                [start] minmax(0, 1fr) [first-col-end] repeat(5, minmax(0, 1fr)) [middle] repeat(
                    5,
                    minmax(0, 1fr)
                )
                [last-col-start] minmax(0, 1fr) [end];
            grid-column-gap: ${e.LARGE};
        }
    `,
  rowGutter: o`
        grid-row-gap: ${e.SMALL};

        @media (min-width: ${m.MEDIUM}rem) {
            grid-row-gap: ${e.MEDIUM};
        }
    `
}, c = "div", t = ({
  children: n,
  component: a,
  hasRowGutter: d = !1,
  ...s
}) => /* @__PURE__ */ l(a || c, { ...s, css: [i.grid, d && i.rowGutter], children: n });
t.propTypes = {
  /** Component type used to render the column */
  component: r.oneOfType([r.string, r.element]),
  children: r.oneOfType([r.node, r.arrayOf(r.node)]).isRequired,
  /** Enable row gutter */
  hasRowGutter: r.bool
};
t.Col = p;
t.Bleed = f;
const L = e.SMALL;
export {
  f as Bleed,
  p as Col,
  L as GRID_GUTTER,
  t as Grid,
  t as default
};
